import React, { useState, useEffect } from 'react';
import { DatePickerCustom, InputCuenta, InputEntidadMultiple, CheckboxButton, CheckboxButtonGroup, FormLabel, FormError } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { object, func } from 'prop-types';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { getDateNow } from '../../../utils/convert';
import { useReporte } from '../../hooks/useReporte';
import { OpenObjectURL } from '../../../utils/helpers';
import { standardRequest } from '../../../utils/requests';
import { APIS } from '../../../config/apis';


const CuentaInformeDeuda = (props) => {

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        idsTasaDeuda: []
    });

    useEffect(() => {
        if (props.data.idCuenta > 0) {
            setState(prevState => {
                return {...prevState,
                    idCuenta: props.data.idCuenta,
                    idTipoTributo: props.data.idTipoTributo
                };
            });
            setValues({...formValues,
                idCuenta: props.data.idCuenta
            });
        }
    }, [props.data.idCuenta]);

    const [formValues, formHandle, , setValues] = useForm({
        idCuenta: 0,
        fechaDesde: null,
        fechaHasta: null,
        fechaMovimientoHasta: getDateNow(),
        fechaDeudaAl: getDateNow(),
        incluirConstanciaDeuda: false,
        excluirConstanciaDeuda: false,
        enviarEmail: false,
        direccionEmail: '',
        numeroCertificadoApremio: '',
        anioCertificadoApremio: '',
        mostrarAccesoriosAgrupados: true,
        excluirAccesoriosApremios: false,
        incluirPersonasRelacionadas: false,
        mostrarCreditos: false,
        mostrarDetalleDeuda: true,
        conMembrete: false,
        idsTasa: []
    });

    useEffect(() => {
        let vigente = true;
        setValues(prevValues => ({...prevValues, idsTasa: []}));
        setState(prevState => ({...prevState, idsTasaDeuda: []}));

        if (formValues.idCuenta > 0) {
            standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.CUENTA_CORRIENTE_ITEM}/deuda/${formValues.idCuenta}`, null, { disableToast: true })
            .then(data => {
                if (!vigente) return;
                const idsTasaDeuda = [...new Set(data.cuentaCorrienteItems.map(item => item.idTasa))];
                setState(prevState => ({...prevState, idsTasaDeuda: idsTasaDeuda}));
            })
            .catch(() => {});
        }

        return () => { vigente = false; };
    }, [formValues.idCuenta]);

    const [ generateReporte, ] = useReporte({
        callback: (reporte, buffer, message) => {
            if (buffer)
                OpenObjectURL(`${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        const filtros = {
            idCuenta: formValues.idCuenta,
            fechaDesde: formValues.fechaDesde,
            fechaHasta: formValues.fechaHasta,
            fechaMovimientoHasta: formValues.fechaMovimientoHasta,
            fechaDeudaAl: formValues.fechaDeudaAl,
            incluirConstanciaDeuda: formValues.incluirConstanciaDeuda,
            excluirConstanciaDeuda: formValues.excluirConstanciaDeuda,
            enviarEmail: formValues.enviarEmail,
            direccionEmail: formValues.direccionEmail,
            numeroCertificadoApremio: formValues.numeroCertificadoApremio,
            anioCertificadoApremio: formValues.anioCertificadoApremio,
            mostrarAccesoriosAgrupados: formValues.mostrarAccesoriosAgrupados,
            excluirAccesoriosApremios: formValues.excluirAccesoriosApremios,
            incluirPersonasRelacionadas: formValues.incluirPersonasRelacionadas,
            mostrarCreditos: formValues.mostrarCreditos,
            mostrarDetalleDeuda: formValues.mostrarDetalleDeuda,
            conMembrete: formValues.conMembrete,
            idsTasa: formValues.idsTasa
        }

        PrintInforme(filtros);
    };

    //functions
    function getErrors() {

        const errors = {};

        if (formValues.idCuenta <= 0) errors.idCuenta = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    function PrintInforme(filtros) {
        const paramsReporte = {
            filtros: filtros
        }
        generateReporte("CuentaInformeDeuda", paramsReporte);
    }


  return (
    <>
        <div className="row">

            <div className="mb-3 col-12 col-md-4">
                <FormLabel htmlFor="idCuenta" required>Cuenta</FormLabel>
                <InputCuenta
                    name="idCuenta"
                    idTipoTributo={state.idTipoTributo}
                    placeholder="Seleccione una cuenta..."
                    className={`form-control ${errorOf('idCuenta') ? 'is-invalid' : ''}`}
                    value={formValues.idCuenta}
                    onChange={formHandle}
                    disabled={state.idCuenta > 0}
                />
                <FormError message={errorOf('idCuenta')} />
            </div>
            <div className="mb-3 col-12 col-md-3">
                <label htmlFor="fechaDeudaAl" className="form-label">Deuda al</label>
                <DatePickerCustom
                    name="fechaDeudaAl"
                    placeholder=""
                    className="form-control"
                    value={formValues.fechaDeudaAl}
                    onChange={formHandle}
                    maxValue={getDateNow()}
                />
                <FormError />
            </div>
            <div className="mb-3 col-12 col-md-3">
                <CheckboxButtonGroup label="Opciones">
                    <CheckboxButton
                        name="mostrarAccesoriosAgrupados"
                        label="Accesorios agrupados"
                        checked={formValues.mostrarAccesoriosAgrupados}
                        onChange={formHandle}
                    />
                </CheckboxButtonGroup>
            </div>
            <div className="mb-3 col-12 col-md-4">
                <label htmlFor="idsTasa" className="form-label">Tasas</label>
                <InputEntidadMultiple
                    name="idsTasa"
                    title="Tasas"
                    entidad="Tasa"
                    placeholder="Todas"
                    className="form-control"
                    values={formValues.idsTasa}
                    onChange={formHandle}
                    filter={(f) => state.idsTasaDeuda.includes(f.id)}
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '25%' },
                        { Header: 'Descripción', accessor: 'descripcion', width: '70%' }
                    ]}
                    onFormat={(row) => (row && row.id) ? `${row.codigo} - ${row.descripcion}` : ''}
                    selectionLabelAccessor={(item) => `${item.codigo} - ${item.descripcion}`}
                    disabled={state.idsTasaDeuda.length === 0}
                />
                <FormError />
            </div>
            
            <div className="col-12 m-top-10">
                <button className="btn back-button" data-dismiss="modal" onClick={props.onDismiss}>Volver</button>
                <button className="btn action-button float-end m-left-5" onClick={ (event) => handleClickAceptar() } >Generar informe</button>    
            </div>

        </div>
    </>
  );
}

CuentaInformeDeuda.propTypes = {
    data: object.isRequired,
    onDismiss: func.isRequired
};

export default CuentaInformeDeuda;
